import Header from "./Header";
import transmission from "./transmission-newnew.mp4";
import "./Home.css"
import Marquee from "react-fast-marquee";
import Image from 'react-bootstrap/Image';
import trans from "./transmission-line.jpg"
import OurTeam from "./OurTeam";
import img1 from './images/salini.jpeg';
import Footer from "./Footer";



function Home(){
 return (
  <>
    <Header />
   <div className="container-fluid">
  
   
   
    {/* <section className="bannerSection aos-init aos-animate" data-aos="fade-in"> */}


    <div className="container-fluid video">
    <div className="row">
    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
    <video preload="auto" loop="true" autoplay="true" muted="true"  ><source src={transmission} /></video>
    </div>
    </div>
    </div>
   {/* </section> */}
   



   <div className="container-fluid">
    <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 news-heading"><h2>LATEST NEWS</h2></div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 news-content"><Marquee>
  I can be a React component, multiple React components, or just some text.
</Marquee></div>
        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 all-news"><a href="/news" className="viewAll arrowLink" title="View All">View All <i class="fa fa-angle-right" aria-hidden="true"></i></a></div>
    </div>
</div>



<div className="container-fluid">
    <h2 className="heading-text"> About Us</h2>
    <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-justify"><p className=""> Levina  Established in 2022, we believe in the efficient utilisation of all available resources. From managing operations, enhancing social and economic benefits, minimizing environmental impacts and employing cutting-edge innovation and provide services such as Construction of Transmission line up to 765KV, Strengthening, Revetment, RFC, O&M and Restoration & Building Construction work, etc. We also deal in providing Manpower Outsourcing at large scale. 
Levina is a major player in providing engineering procurement Construction (EPC) services for developing power, infrastructure and road projects.
Levina is also a leading utility Company having presence across the value chain of power businesses i.e. transmission & distribution.
At the heart of all of this, is our people. We take much pride in fostering an inspiring workplace, with an agile and high-performance culture. We are also deeply committed to recognising and valuing diversity across our teams.

</p></div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-class"><Image src={trans} fluid/></div>
    </div>
</div>

<div className="container-fluid our-mission">
    <h2 className="heading-text">Our Mission</h2>
    <div className="row">

        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 image-class"><Image src={trans} fluid/></div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 text-justify">To develop and deliver high quality services to our client satisfaction in consonance with the vision of “LEVINA”.
Our achievements are a testimony to our mission of attaining excellence in infrastructure.
The following ideas form the cornerstone of our endeavour to realize our goal:
To attain global best practices and become a world-class utility.
To create world-class assets and infrastructure to provide the platform for faster, consistent growth for India to become a major world economic power.
To achieve excellence in service, quality, reliability, safety.
To earn the trust and confidence of all customers and stakeholders, exceeding their expectations and make the Company a respected household name.
To work with vigour, dedication and innovation with total customer satisfaction as the ultimate goal.
To consistently achieve high growth with the highest levels of productivity 
To be a technology driven, efficient and financially sound organisation
To be responsible corporate citizens nurturing human values and concern for society, the environment and above all people
To contribute towards community development and nation building
To promote a work culture that fosters individual growth, team spirit and creativity to overcome challenges and attain goals
To encourage ideas, talent and value systems
To uphold the guiding principles of trust, integrity and transparency in all aspects of interactions and dealings.
</div>
    </div>
</div>
<OurTeam />
<div className="container-fluid">
    <h2 className="heading-text"> Director's Message</h2>
    <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-justify"><p className=""> In the current process of widespread globalization, we in LEVINA understand that meeting our client's requirement is essential to the success of our Organization. We can say that the months we experienced in the past are significant months and it is clearly seen that we have intensively delivery our best performance to focus on client’s satisfaction.
On behalf of the Board of Directors, I would like to thank our valuable clients, reliable dealers and world-class suppliers. Besides, I would like to make a special mention of our staffs’ enthusiastic contribution in establishing our Organization. The one thing I would like to present is that our leadership is a result of our employees. They have clearly made LEVINA one of the best Organization. We know our highly trained engineers apply their specialized knowledge to reliably and efficiently produce high quality services.
We are now in an ever-changing market environment. In such situation, we firmly believe that “trust” is the key element in persuading clients to choose our quality products. We totally accept that “trust” can create a “Win-Win Situation” for a long deeper relationship.
It is easy to find them in every corner industrial activity and community living. We will continue our endless effort to serve our valuable clients.
In addition, we in LEVINA will intensively endeavour in environmental awareness for preventing from climate changes and resources depletion. We are committed to preservation of the environment we live in. So in summary, I would like to thank again all those who have contributed relentless hard work and effort of the past to bring up here today and will continue to grow for years to come.

</p></div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-class"><Image src={img1} fluid roundedCircle thumbnail/></div>
    </div>
</div>

</div>
<Footer />
</>
 );
 
}

export default Home;